export default [
  {
    key: 'field1',
    title: '开关',
    width: 40
  },
  {
    key: 'id',
    title: '媒体ID',
    width: 40
  },
  {
    key: 'mediaName',
    title: '媒体名称',
    width: 100
  },
  {
    key: 'field4',
    title: '媒体登录地址',
    width: 250
  },
  {
    key: 'rebate',
    title: '媒体汇率',
    width: 60
  },
  {
    key: 'status',
    title: '媒体状态',
    width: 60
  },
  {
    key: 'createTime',
    title: '创建时间',
    width: 120
  },
  {
    key: 'opName',
    title: '创建人',
    width: 100
  },
  {
    key: 'upOpName',
    title: '修改人',
    width: 100
  },
  {
    key: 'upTime',
    title: '修改时间',
    width: 120
  },
  {
    key: 'control',
    title: '操作',
    width: 50
  }
]
